import { Text, View, StyleSheet } from '@react-pdf/renderer';

interface TableRow {
  weekStartDate: string;
  loggedIn: boolean;
  learning: boolean;
  assessment: boolean;
}
const styles = StyleSheet.create({
  table: { display: 'flex', width: '100%', marginTop: 20, marginBottom: 20 },
  row: {
    flexDirection: 'row',
  },
  cell: { padding: 5, flex: 1, textAlign: 'center' },
  header: { borderBottomWidth: 2, borderBottomColor: '#cfced0' },
});

function PDFTable({ data }: { data?: TableRow[] }): React.ReactElement {
  return (
    <View style={styles.table}>
      <View style={[styles.row, styles.header]}>
        <Text style={styles.cell}>Week start date</Text>
        <Text style={styles.cell}>Logged in</Text>
        <Text style={styles.cell}>Learning</Text>
        <Text style={styles.cell}>Assessment</Text>
      </View>
      {data?.map((row, i) => (
        <View style={styles.row} key={i}>
          <Text style={styles.cell}>{row.weekStartDate}</Text>
          <Text style={styles.cell}>{row.loggedIn ? 'Yes' : '-'}</Text>
          <Text style={styles.cell}>{row.learning ? 'Yes' : '-'}</Text>
          <Text style={styles.cell}>{row.assessment ? 'Yes' : '-'}</Text>
        </View>
      ))}
    </View>
  );
}

export default PDFTable;
